module.exports = __webpack_public_path__ + "static/media/heading_logo.eb2a6397.png";